import styled from "styled-components";
import { palette, size, font } from "styled-theme";

const Wrapper = styled.div`
  text-align: center;
  &.uppercase {
    text-transform: ${font("headingCase")};
  }
  .page-heading {
    color: ${palette("color", 35)};
    font-size: ${size("h4")};
    font-weight: normal;
    letter-spacing: -0.2px;
    text-align: center;
    
    display: block;
    @media only screen and (max-width: ${size("S")}) {
      display: ${({$asMobileHeader, $hideMobile}) => $asMobileHeader || $hideMobile ? "none" : "block"}; 
    }
  }
  .page-subheading {
    font-size: 14px;
    color: ${palette("color", 21)};
    line-height: 1.5;
  }

  a:not(.apply-link){
    color:${palette("link", 0)};
    text-decoration: none;
  }
  a:not(.apply-link):hover{
    color:${palette("link", 1)};
    text-decoration: underline;
  }
  .apply-link {
    display: block;
    margin: 0 auto;
    margin-top: 20px;
  }
  .isBlackHeading {
    color:${palette("formInputElement", 0)};
  }
`;

export default Wrapper;
